import React, { useState, useEffect } from "react";
import { Bar } from "react-chartjs-2";
import { KeywordsWordCloud, sentimentTypeData, KeywordsWordCloud_cloud } from "../data/dummy";
import { useStateContext } from "../contexts/ContextProvider";
import { useLocation, useNavigate } from "react-router-dom";
import { Header, Button } from "../components";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import KeywordFrequencyTable from "../components/KeywordFrequencyTable";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const VisualizeWordFrequencyDatail = () => {
  const navigate = useNavigate();
  const [unixTime, setUnixTime] = useState('');
  const [userId, setUserId] = useState('');
  const { currentColor } = useStateContext();
  const location = useLocation(); // useLocation 사용

  const containerHeight = Math.max(500, KeywordsWordCloud.length * 25 * 1.2);
  const [intentName, setIntentName] = useState(location.state?.intentName || "");
  const [sentiment, setSentiment] = useState(location.state?.sentiment || "");

  // location.state가 undefined일 경우 기본값으로 초기화
  const [keywords, setKeywords] = useState(location.state?.keywords || KeywordsWordCloud_cloud[intentName][sentiment]);
  const [keywordColors, setKeywordColors] = useState(location.state?.keywordColors || {});
  
  

  const handleColorChange = (keyword, color) => {
    setKeywordColors((prevColors) => ({
      ...prevColors,
      [keyword]: color,
    }));
  };

  const handleKeywordRemove = (removedKeyword) => {
    setKeywords(keywords.filter((k) => k.text !== removedKeyword));
    setKeywordColors((prevColors) => {
      const updatedColors = { ...prevColors };
      delete updatedColors[removedKeyword];
      return updatedColors;
    });
  };

  const goBack = () => {
    navigate("/vis/wordfreq", { state: { keywords, keywordColors } });
  };

  const data = {
    labels: keywords.map((item) => item.text),
    datasets: [
      {
        label: "키워드 빈도",
        data: keywords.map((item) => item.value),
        backgroundColor: keywords.map(
          (item) => keywordColors[item.text] || "rgba(75, 192, 192, 0.5)"
        ),
        borderColor: "rgba(75, 192, 192, 1)",
        borderWidth: 1,
      },
    ],
  };

  const options = {
    indexAxis: "y",
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: { beginAtZero: true },
    },
    plugins: {
      legend: { display: false },
    },
  };

  useEffect(() => {
    const storedUserID = localStorage.getItem('userId');
    setUserId(storedUserID || '');
    console.log(`storedUserID: ${storedUserID}`);

    const storedUnixTime = localStorage.getItem('unixTime');
    setUnixTime(storedUnixTime || '');
    console.log(`storedUnixTime: ${storedUnixTime}`);
  }, []);

  return (
    <div className="m-2 md:m-10 mt-0 p-2 md:p-10 bg-white rounded-3xl">
      <Button
        color="white"
        bgColor={currentColor}
        text="이전 페이지"
        borderRadius="10px"
        onClick={goBack}
      />
      <br/><br/>
      <div className="flex gap-5">
        <p className="text-xl font-semibold">
          {`키워드 빈도 차트 편집 페이지 - ${intentName} ${sentiment} 리뷰`}
        </p>
      </div>
      <div className="bg-white p-8 rounded-3xl shadow-lg mb-12 gap-10">
        <div className="flex">
          <div className="flex-[4] pr-4" style={{ height: `${containerHeight}px` }}>
            <Bar data={data} options={options} />
          </div>
          <div className="flex-[1]">
            <KeywordFrequencyTable
              sentiment={sentiment} intent={intentName}
              keywordColors={keywordColors}
              onColorChange={handleColorChange}
              onKeywordRemove={handleKeywordRemove}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default VisualizeWordFrequencyDatail;
